import { MenuContext } from "./MenuContext";
import { MenuItem, MenuLinkItem } from "./MenuItems";
import { MenuMore } from "./MenuMore";
import { MenuGroup, MenuGroupLabel, MenuSeparator } from "./MenuParts";
import { MenuRadioGroup, MenuRadioItem } from "./MenuRadio";
import { MenuRoot, MenuTrigger } from "./MenuRoot";
import { MenuSubmenu } from "./MenuSubmenu";
import { MenuToggleItem } from "./MenuToggleItem";

export type {
    MenuClassNames,
    MenuContextProps,
    MenuForcedState,
    MenuGroupLabelProps,
    MenuGroupProps,
    MenuItemProps,
    MenuLinkItemProps,
    MenuMoreProps,
    MenuRadioGroupProps,
    MenuRadioItemProps,
    MenuRootProps,
    MenuSeparatorProps,
    MenuSubmenuClassNames,
    MenuSubmenuProps,
    MenuToggleItemProps,
    MenuTriggerProps,
} from "./Menu.types";

/**
 * The action menu: Base UI `Menu` styled from the Figma `_Select/*`
 * anatomy. `Root` opens from its `trigger` element, `More` is the kebab
 * preset, `Context` opens on right-click; every other key is a part placed
 * inside a root.
 */
export const Menu = {
    Root: MenuRoot,
    Trigger: MenuTrigger,
    More: MenuMore,
    Context: MenuContext,
    Item: MenuItem,
    LinkItem: MenuLinkItem,
    Submenu: MenuSubmenu,
    ToggleItem: MenuToggleItem,
    RadioGroup: MenuRadioGroup,
    RadioItem: MenuRadioItem,
    Group: MenuGroup,
    GroupLabel: MenuGroupLabel,
    Separator: MenuSeparator,
};
